import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT = {
  brand_name: "Netlen Canlı Destek",
  logo_url: "/netlen-icon.png",
  favicon_url: "/favicon.png",
  footer_text: "© 2026 Netlen İnternet Hizmetleri",
  login_subtitle: "AI destekli canlı destek sistemi",
  primary_color: "#1c91ef",
};

const BrandingContext = createContext(DEFAULT);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT);

  useEffect(() => {
    const hostname = window.location.hostname;
    axios.get(`${API}/branding?hostname=${encodeURIComponent(hostname)}`)
      .then(({ data }) => {
        setBranding({ ...DEFAULT, ...data });
        // Favicon güncelle
        if (data.favicon_url) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
          link.href = data.favicon_url;
        }
        // Sayfa başlığı güncelle
        if (data.brand_name) document.title = data.brand_name;
      })
      .catch(() => {});
  }, []);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
